import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/groupLeader',
    name: 'groupLeader',
    meta,
    redirect: { name: 'groupLeader' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'groupLeaderList',
            name: `${pre}groupLeaderList`,
            component: _import('groupLeader/groupLeaderList'),
            meta: {
                ...meta,
                title: '团长申请审核'
            }
        },
		{
		    path: 'groupLeaderConfig',
		    name: `${pre}groupLeaderConfig`,
		    component: _import('groupLeader/groupLeaderConfig'),
		    meta: {
		        ...meta,
		        title: '团队长佣金设置'
		    }
		},
		{
		    path: 'groupLeaderCommission',
		    name: `${pre}groupLeaderCommission`,
		    component: _import('groupLeader/groupLeaderCommission'),
		    meta: {
		        ...meta,
		        title: '团长佣金记录'
		    }
		},
		{
		    path: 'groupLeaderWithdraw',
		    name: `${pre}groupLeaderWithdraw`,
		    component: _import('groupLeader/groupLeaderWithdraw'),
		    meta: {
		        ...meta,
		        title: '团长提现审核'
		    }
		},
		
		{
		    path: 'groupLeaderWithdrawConfirm',
		    name: `${pre}groupLeaderWithdrawConfirm`,
		    component: _import('groupLeader/groupLeaderWithdrawConfirm'),
		    meta: {
		        ...meta,
		        title: '团长提现打款'
		    }
		},
    ])('groupLeader-')
}
